import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
};

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）${movie.type}海报`}
          title={`${movie.title} - ${movie.type} - 八戒影视`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-[11px]">
          {movie.type}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{movie.actors.join(" / ")}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-[11px] text-foreground-400">{movie.year} · {movie.country}</span>
          <span className="text-[11px] text-secondary-700 truncate max-w-[80px]">{movie.genres[0]}</span>
        </div>
      </div>
    </Link>
  );
}